import { getUrlDefaults } from '~/src/Lib/Nav'

const urls = getUrlDefaults('notes')

export default urls
